module.exports = __webpack_public_path__ + "img/4.296b82e.jpg";